/*
 *  Takes a letter as an argument and returns the next letter in the alphabet. Accounts for A -> Z and a -> z
 *  Thanks to @kennebec https://stackoverflow.com/a/2256724
 *  @param {String} letter
 *  @return {String} nextLetter
 */
export default (letter) => {
  return letter.replace(/([a-zA-Z])[^a-zA-Z]*$/, (a) => {
    let c = a.charCodeAt(0)
    switch (c) {
      case 90: return 'A'
      case 122: return 'a'
      default: return String.fromCharCode(++c)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/helpers/GetNextLetter.js